let WEBSOCK_URL;

class WebSockAPI {
    
    constructor() {
        this.socket = null;
        this.reqid = 0;
        this.cb = {}; //note: this can get quite large!!
        //todo: if closed then we should error out cbs that have not returned
    }
    connect(accessToken) {
        if(!WEBSOCK_URL) {
            //todo figure out websock url - is this right?
            fetch(process.env.REACT_APP_API_NAMESPACE + '/config/ws').then((res) => {
                res.json().then((w) => {
                    WEBSOCK_URL = w.websocket_url;
                    return this.connectURL(WEBSOCK_URL, accessToken);            
                });
            });
        } else {
            return this.connectURL(WEBSOCK_URL, accessToken);
        }
    }
    connectURL(url, accessToken) {
        if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
            console.warn("WebSocket is already connected or connecting.");
            return;
        }
        this.socket = new WebSocket(url+"?token="+encodeURIComponent(accessToken));
        this.socket.onopen = (event) => {
            console.log(`[WebSocket] Connected to ${url}`);
        };
        this.socket.onmessage = (event) => {
            let data;
            try {
                // Attempt to parse JSON data automatically
                data = JSON.parse(event.data);
            } catch (e) {
                // Fallback to raw string if it's not JSON
                data = event.data;
            }
            console.log("WS data",data, event);
            const prom = data?.reqid && this.cb[data?.reqid];
            if(prom) {
                delete this.cb[data.reqid];
                prom.resolve(data);
            }
        };
        this.socket.onclose = (event) => {
            console.log(`[WebSocket] Connection closed (Code: ${event.code})`);
            this.socket = null;
        };
        this.socket.onerror = (error) => {
            console.error('[WebSocket] Error occurred', error);
        };
    }

    send(action, payload = {}, prom = null) {
        if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
            console.error("[WebSocket] Cannot send message: connection is not open.");
            return;
        }
        this.reqid++;
        const messageData = JSON.stringify({
            action: action,
            ...payload,
            reqid: this.reqid
        });
        this.cb[this.reqid] = prom;
        this.socket.send(messageData);
    }
    close(code = 1000, reason = "Client closed connection") {
        if (this.socket) {
            this.socket.close(code, reason);
            const rej = this.cb;
            const err = new Error("socket closed");
            this.cb = {}
            Object.values(rej).map((p) => p.reject(err));
        }
    }
}

// Create singleton from Auth service
const websockapi = new WebSockAPI();
export default websockapi;
